import React, { lazy, Suspense} from 'react';

import Advantage from '../components/Advantage';
import TextHM from '../components/Text';
import TEMP from '../components/TEMP';
import { Spinner } from 'react-bootstrap';

const Banner = lazy(() => import('../components/Banner'));
const Cards = lazy(() => import('../components/Cards'));
const YandexMap = lazy(() => import('../components/YandexMap'));

const mediaAsset = {
  video:{
    production_video: new URL('../static/background/background.webm', import.meta.url).href,
    production_video_mp4: new URL('../static/background/background.mp4', import.meta.url).href
  }
}

const SECTIONS = [
  {title:'Товары', component:Cards},
  {title:'Преимущества', component:Advantage},
  {title:'Где нас можно найти?', component:YandexMap},
]

function Homepage() {
  return (
    
    <div className='content'>
      <Suspense fallback={<Spinner animation='grow'/>}>
        <Banner
          videoUrl={
            mediaAsset.video.production_video
          } key={"video1"}
          text={
            <>
              ВОЛГОГРАДСКИЙ <br />ОБЛИЦОВОЧНЫЙ КИРПИЧ
            </>
          }
        />
        <div className='description'>
          <TEMP />
        </div>

        {
          SECTIONS.map((section,index)=>(
            <React.Fragment key={index}>
              <TextHM prop={section.title}/>
              <section.component/>
            </React.Fragment>
          ))
        }

      </Suspense>
    </div>
  );
}

export default Homepage;